const ITEMS = [
  "REAL NATURAL BODYBUILDING",
  "SIN ATAJOS",
  "100% NATURAL",
  "DANI POSTIGO",
  "CO-FUNDADOR OCB SPAIN",
  "TU CUERPO ES TU PROYECTO MÁS IMPORTANTE",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display text-2xl sm:text-3xl tracking-[0.15em] text-zinc-700 px-6 whitespace-nowrap">{t}</span>
        <span className="h-2 w-2 bg-zinc-800 rotate-45" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="rnb-editorial-marquee" className="relative overflow-hidden border-y border-zinc-900 bg-[#080808] py-5" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
